import {createAuthenticatedFetch} from '~/utils/createAuthenticatedFetch'

export default defineNuxtPlugin((nuxtApp) => {
    const refreshToken = useCookie('GATEWAY_REFRESH', { path: '/proxy/account-recovery-api.bpmn/auth/login/refresh/token' })
    const cookieStore = useCookieStore();

    const config = useRuntimeConfig()
    const host = config.public.tapLink;
    const baseURL = import.meta.server ? `https://${host}` : ''

    const apiFetch = $fetch.create({
        baseURL: baseURL,

        onRequest({ options }) {
            if (cookieStore.currentToken()) {
                const headers = new Headers(options.headers)
                headers.set('Authorization', `Bearer ${cookieStore.currentToken()}`)
                options.headers = headers
            }
        },

        async onResponse({ request, response }) {
            if (typeof response._data === 'string' && response._data.includes('Request Rejected')) {
                const match = response._data.match(/Your support ID is:\s*(\d+)/);
                const supportId = match ? match[1] : null;

                if (supportId) {
                    $fetch('/proxy/tracking-action.bpmn/api/v1/event/tb/send', {
                        baseURL: baseURL,
                        method: 'POST',
                        body: {
                            message: `Your support ID is: ${supportId}. Path: ${typeof request === 'string' ? request : request.url}`,
                            type: "DAW"
                        }
                    }).catch(err => {
                        if (import.meta.server) {
                            console.error('Не удалось отправить Support ID с сервера:', err)
                        }
                    });
                }
                throw new Error(`Request Rejected by WAF. Support ID: ${supportId}`);
            }
        }
    })

    const api = createAuthenticatedFetch(apiFetch, {
        server: import.meta.server,
        getToken: cookieStore.currentToken,
        async refreshAccessToken() {
            const data = await $fetch('/proxy/account-recovery-api.bpmn/auth/login/refresh/token', {
                baseURL,
                method: 'POST',
                credentials: 'include',
                retry: 0,
                timeout: 15000
            })
            if (typeof data?.access_token !== 'string' || !data.access_token) {
                throw new Error('Token refresh did not return an access token')
            }
            cookieStore.updateToken(data.access_token)
            if (typeof data.refresh_token === 'string' && data.refresh_token) refreshToken.value = data.refresh_token
            return data.access_token
        },
        onSessionExpired: () => nuxtApp.runWithContext(() => {
            cookieStore.updateToken(null)
            refreshToken.value = null
            useUserStore().expireSession()
            const dialogStore = useDialogStore()
            if (dialogStore.isOpen) dialogStore.close(true)
            const route = nuxtApp.$router.currentRoute.value
            return navigateTo({
                path: '/',
                query: {...route.query, ...(route.path !== '/' ? {redirect: route.path} : {})}
            }, {replace: true})
        })
    })

    return {
        provide: {
            api
        }
    }
})
